// extracted by mini-css-extract-plugin
export default {"wrapper":"inline-svg-module--wrapper--f0460"};